export default __webpack_public_path__ + "static/media/banner_servicios.8427fef4.png";